<template>
  <ValidationObserver :vid="id" rules="checked" v-slot="{ errors }">
    <div
      :key="id"
      v-for="({ id, name, title, slot, checked, subtitle, disabled }, index) in selectorsData"
      :class="['toggle-selector', isHalfWidth && 'toggle-selector--half']"
      :data-testid="'dynamic-selector-' + id"
    >
      <span>{{ updateValidation(errors) }}</span>
      <CheckboxCard
        :id="id"
        :name="name"
        :rules="mustBeChecked"
        :checked="checked"
        :title="title"
        :subtitle="subtitle"
        :disabled="disabled"
        :errorChecked="hasErrors"
        :classes="'checkbox-card__responsive_div_buttons'"
        @toggle="$emit('toggle', index)"
      >
        <section v-if="slot && slot.component && checked">
          <component :is="slot.component" v-bind="slot.props" />
        </section>
        <section v-if="slot && checked">
          <slot :name="slot" />
        </section>
      </CheckboxCard>
    </div>
    <TransitionExpand>
      <div v-if="hasErrors" class="col-12 field__error pl-0">
        {{ translate('ppSelectAtLeastOne') }}
      </div>
    </TransitionExpand>
    <div v-if="isTravelAgent" class="toggle-selector__cannot-deselect">
      <i class="icon-info xs color-black" />
      <span class="toggle-selector__deselect-label" v-html="boldTextForCannotDeselect()"/>
    </div>
  </ValidationObserver>
</template>

<script>
import CheckboxCard from '@/components/form-controls/CheckboxCard'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import TransitionExpand from '@/components/transitions/TransitionExpand'
export default {
  name: 'DynamicToggleSelector',
  components: {
    CheckboxCard,
    ValidationObserver,
    ValidationProvider,
    TransitionExpand
  },
  props: {
    selectorsData: {
      type: Array
    },
    isTravelAgent: {
      type: Boolean
    },
    isHalfWidth: {
      type: Boolean
    },
    id: {
      type: String
    }
  },
  data() {
    return {
      fieldNames: [],
      errors: ''
    }
  },
  computed: {
    mustBeChecked() {
      return this.selectorsData.some(elem => elem.checked === true) ? '' : 'checked'
    },
    hasErrors() {
      return this.errors
        ? Object.entries(this.errors).some(
          ([key, value]) => this.fieldNames.indexOf(key) > -1 && value.length !== 0
        )
        : false
    }
  },
  created() {
    this.fieldNames = this.selectorsData.map(entry => entry.name)
  },
  methods: {
    updateValidation(errors) {
      this.errors = errors
    },
    boldTextForCannotDeselect() {
      const toReplace = this.translate('ppMemberServices')
      const fullText = this.translate('ppCannotDeselect', undefined, toReplace)
      return fullText.replace(toReplace, `<a style="color:black" href="translate('ppMemberServicesLink')"><strong>${toReplace}</strong></a>`)
    }
  }
}
</script>

<style scoped lang="scss">
.toggle-selector {
  margin-top: 2rem;

  &--half {
    @media (min-width: 992px) {
      width: 50%;
      padding-right: 1.2rem;
    }
  }

  &__cannot-deselect {
    font-size: 1.2rem;
    color: color('grey-cool');
    display: flex;
  }

  &__deselect-label {
    margin-left: 0.5rem;
  }
}
</style>
